import Axios from 'axios';

const API = process.env.VUE_APP_WS_ENDPOINT;

const GET_APPS = '/Global/system/status';
const SET_APP = '/Global/system/add';

export default {
    getApps(payload) {
        return Axios.post(`${API}${GET_APPS}`, payload ? payload : {id:0,activo:0});
    },
    setApps(payload) {
        return Axios.post(`${API}${SET_APP}`, payload);
    }
};